<template>
    <div class="gray-back" >
        <div class="box">
            <van-dropdown-menu v-if="false">
                <van-dropdown-item  :options="[
        { text: '全部商品', value: 0 },
      ]" />
                <van-dropdown-item  :options="[
        { text: '全部商品', value: 0 },
      ]" />
            </van-dropdown-menu>
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                >
                    <div class="kaojicenter-list-box">
                        <div class="kaojicenter-lists flex-between" v-for="(item, index) in list"
                             @click="action(item, index)">
                            <div class="kaojicenter-lefts">
                                <img class="img" :src="item.pic_url" alt="" />
                            </div>
                            <div class="kaojicenter-rights">
                                <div class="title">{{item.name}}</div>
                                <div class="desc flex-start">
                                    <van-tag round :color="item.grade|color" type="primary">{{item.grade}}星级</van-tag>  &nbsp;
                                     {{item.num}}
                                </div>
                            </div>
                        </div>
                    </div>
                    </van-list>
                </van-list>
            </van-pull-refresh>


            <van-action-sheet v-model="actionShow" :actions="actions" @select="onActionSelect" />

        </div>



    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 50px;*/
        background: rgba(248,248,248,1);
        min-height: 90vh;
    }
    .kaojicenter-list-box {
        padding-top: 0.2rem;
        /*background: rgba(248,248,248,1);*/
    }

    .goods-line {
        height: 55px;
    }

    .goods-bottom-line {
        width: 100%;
        position: fixed;
        height: 60px;
        bottom: 0;
        background: linear-gradient(180deg, hsla(255, 0%, 100%, 0), #fff);
    }

    .goods-create-btn {
        position: fixed;
        bottom: 10px;
        width: 100%;
        height: 44px;
        font-size: 16px;
        text-align: center;
    }

    .goods-create-btn button {
        width: 3.2rem;
    }

    .goods-create-btn img {
        width: 60px;
        height: 60px;
    }

    .goods-header {
        display: flex;
        justify-content: space-between;
        position: fixed;
        top: 0;
        z-index: 99;
        width: 100%;
        margin-bottom: 0.01rem;
        background: #fff;
    }

    .van-tabs {
        width: 85% !important;
    }

    .screen-btn {
        line-height: 44px;
        height: 44px;
    }

    .screen-btn img {
        width: 45%;
        padding-left: 15px;
        vertical-align: middle;
        border-left: 1px solid #D5D5D5;
    }

    .sidebar {
        padding-top: 15px;
    }

    .search-box img {
        width: 60px;
        height: 60px;
    }


    .select-btn {
        position: fixed;
        bottom: 0;
        width: 90%;
        margin: 0 auto;
        padding: 0px 15px 30px;
    }

    .btn-reset {
        padding-bottom: 10px;
    }

    .btn-reset >>> .van-button {
        background: #ddd;
    }

    .selected {
        color: #444;
    }


    .kaojicenter-lists {
        padding: 0.2rem;
        border-radius:10px;
        background: #fff;
        margin: 0 0.2rem 0.2rem;
    }

    .kaojicenter-lefts {
        position: relative;
    }


    .kaojicenter-lefts .img {
        border-radius: 10px;
        width: 1rem;
        height: 1rem;
    }

    .kaojicenter-rights {
        width:calc(100% - 1.2rem);
        position: relative;
        height: 1rem;
    }

    .kaojicenter-rights .title{
        font-size: 15px;
        font-weight: bold;
    }
    .kaojicenter-rights .desc{
        font-size: 12px;
        padding-top: 10px;
        color: #999;
    }



</style>

<script>
    import Vue from 'vue';

    import {Cell, CellGroup, Toast, Dialog, Icon, PullRefresh, List, Tag, Button,DropdownMenu, DropdownItem} from 'vant';

    Vue.use(Cell).use(CellGroup).use(Toast).use(Dialog).use(Icon).use(Tag).use(Button).use(DropdownMenu).use(DropdownItem);
    export default {
        name: 'ExameApplyMemberList',
        components: {
            [PullRefresh.name]: PullRefresh,
            [List.name]: List,
        },
        data: function () {
            return {
                id: 0,
                actionShow: false,
                list: [],
                actions:[
                    { name: '编辑' },
                    { name: '连考' },
                    { name: '删除' },
                ],
                formData: {
                    kaoji_id:this.$route.query.kaoji_id,
                    pageNo: 1,
                    pageSize: 10,
                    keywords: '',
                    cate_id: 0,
                    status: 1
                },
                isLoading: false,
                loading: false,
                finished: false,

            }
        },
        mounted() {
            document.title = "考级中心考级点"
            this.getList();
        },
        filters:{
            color(value){
                switch (value){
                    case '红' :
                        return '#ff0000'
                        break;
                    case '橙' :
                        return '#FF9966'
                        break;
                    case '黄' :
                        return '#FFFF33'
                        break;
                    case '绿' :
                        return '#33CC33'
                        break;
                    case '青' :
                        return '#6699CC'
                        break;
                    case '蓝' :
                        return '#003366'
                        break;
                    case '紫' :
                        return '#663399'
                        break;

                }
            }
        },
        destroyed() {
        },
        methods: {
            getList() {
                let that = this;
                that.$api.get('/api/qcxj/applyMemberList', that.formData, (res) => {
                    that.loading = false;

                    if (res.data.currentpage == 1) {
                        that.isLoading = false;
                        that.list = res.data.list
                    } else {
                        let list = that.list.concat(res.data.list);

                        that.list = list;
                    }

                    if (res.data.list.length == 0) {
                        that.finished = true;
                    }
                    that.formData.pageNo += 1;
                })
            },


            // 上拉加载
            // （页面显示没有更多了的原因 ）数据加载过慢 导致第一页数据未获取到时，已经请求第二页数据了
            // 可以延迟异步的时间
            onLoad() {
                // console.log(1)
                // 异步更新数据
                console.log('this.formData.pageNo')

                if (this.formData.pageNo > 1) {
                    setTimeout(() => {
                        this.getList()
                    }, 500);
                }

            },

            action(item,index){

                this.actionShow = true;
                this.formData.id = item.id;
                this.formData.name = item.name;

            },
            onActionSelect(action,index){
                let that = this;
                switch (index){
                    case 0 :
                        //编辑
                        rbLink({
                            name:'ExameApplyMemberDetail',
                            query:{
                                id:that.formData.id
                            }
                        })
                        break;
                    case 1 :
                        //连考
                        rbLink({
                            name:'ExameApplyMemberAddMore',
                            query:{
                                id:that.formData.id
                            }
                        })
                        break;
                    case 2 :
                        //删除

                        Dialog.confirm({
                            title: '确认',
                            message: '是否删除该运动员?',
                        })
                                .then(() => {
                                    // on confirm
                                    that.$api.post('/api/qcxj/kaojiMemberDelete', {
                                        id:that.formData.id
                                    }, (res) => {
                                        that.getList();
                                    }, (res) => {
                                        Toast.fail(res.msg);
                                    })

                                })
                                .catch(() => {
                                    // on cancel
                                });

                        this.actionShow = false;
                        break;

                }
            },

            onRefresh() {
                let that = this;
                that.formData.pageNo = 1;
                that.getList();
            },

        }
    }
</script>



// WEBPACK FOOTER //
// ExameApplyMemberList.vue?03723c52